export default __webpack_public_path__ + "static/media/Logo.1164cd68.jpg";